import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[viewModeHost]',
    standalone: false
})
export class ViewModeDirective {
  viewContainerRef = inject(ViewContainerRef);

}
